import _filter from 'lodash/filter';
import { CYOA_NETWORK_IDS } from '../config';

/**
 * HOHO BUILDER (CYOA) - FINAL PAYLOAD BEFORE PAYMENT
 *
 * @param {Array} arr - Booking response payload
 */
 export function UpdateFinalPayload(arr){

   let _trips = {};
   let _passengers = [];
   let _reservations = [];

   //Find trips based on booking_identifier of first openItineraryModal
   const finalReservation = _filter(arr.trips, (o) => {return o.tour_id === CYOA_NETWORK_IDS["europe"].id || o.tour_id === CYOA_NETWORK_IDS["usa"].id})[0];


  _trips.booking_identifier = (finalReservation.booking_identifier === null) ? null : finalReservation.booking_identifier;

  //Only add first passengers reservation details - ignoring the first item with reservation identifier
  for(let jj = 0; jj < finalReservation.passengers[0].reservations.length; jj++){
    if(finalReservation.passengers[0].reservations[jj].reservation_identifier === null){
      _reservations.push({
        "laravel_reservation_identifier":finalReservation.passengers[0].reservations[jj].laravel_reservation_identifier,
        "date_for":finalReservation.passengers[0].reservations[jj].date_for,
        "start_city_id":finalReservation.passengers[0].reservations[jj].start_city_id,
        "end_city_id":finalReservation.passengers[0].reservations[jj].end_city_id,
        "price": finalReservation.passengers[0].reservations[jj].price
      });
    }
  }

  for(let j = 0; j < finalReservation.passengers.length; j++){
     _passengers.push({
      "trip_passenger_identifier":finalReservation.passengers[j].trip_passenger_identifier,
      "price": finalReservation.passengers[j].price,
      "reservations":_reservations
    });

  }

   _trips.passengers = _passengers;

   return { "trips": [ _trips ]};
 }



 /**
  * HOHO BUILDER (CYOA) - ADD TRIP PAYLOAD
  *
  * @param {Array} arr - Booking response payload
  * @param {String} tourID - Tour ID of trip
  * @param {String} departureDate - departure date of trip
  * @param {String} cityID - City ID of the last reservation item 'end_city_id'
  */
  export function AddTripPayload(arr, tourID, departureDate, cityID="0"){

    let payload = {};
    let passengers = [];

    payload.booking_information = {
     "iso_currency_code":arr.trips[0].iso_currency_code
    }

    payload.trips = [{
      "tour_id": tourID,
      "city_id":cityID,
      "departure_date": departureDate
    }];

   for(let i = 0; i < arr.passengers.length; i++){
     passengers.push({
       "passenger_identifier":arr.passengers[i].passenger_identifier
     })
   }

    payload.passengers = passengers;

    return payload;
  }


/**
 * HOHO BUILDER - REMOVE TRIP RESERVATION PAYLOAD
 *
 * @param {Array} arr - Booking response payload
 */
 export function RemoveTripPayload(arr, id){

   const removeTrip = _filter(arr.trips, ['booking_identifier', id])[0];

   let _trips = {};
   let _passengers = [];

   _trips.booking_identifier =  removeTrip.booking_identifier;

   for(let j = 0; j < removeTrip.passengers.length; j++){
    _passengers.push({
      "trip_passenger_identifier":removeTrip.passengers[j].trip_passenger_identifier,
      "cancel": true
    });
   }
   _trips.passengers = _passengers;

   return { "trips": [ _trips ]};
 }



// WEBPACK FOOTER //
// ./src/helpers/bookingHelper.js